import React from 'react';
import styled from 'astroturf/react';

import routes from 'js/core_pre_webpack/routes';
import $image_url from 'js/utils/image_url';

const CellLink = styled.a`
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  height: 100%;
  padding: 0 20px 0 24px;
  border-right: 1px solid var(--stroke-light, #dddde2);

  &:active {
    background: var(--background-light-blue, #eef2f9);
  }
`;

const LogoImg = styled.img`
  width: 26px;
  height: 23px;
`;

const LogoCell = () => (
  <CellLink
    href={routes.home_url({ from_navbar: true, trigger: 'nav' })}
    aria-label="Academia.edu home"
    data-testid="logo-cell"
  >
    <LogoImg
      src={$image_url('academia-logo-2021.svg')}
      alt=""
      data-testid="logo-img"
    />
  </CellLink>
);

export default LogoCell;
